import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Local = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Local' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,4 L23,4 L23,20 L1,20 L1,4 Z M11,8 L23,8 M1,16 L23,16 M1,12 L23,12 M11,4 L11,12' />
  </StyledIcon>
);
